import { createFileRoute } from '@tanstack/react-router'
import Homepage2 from '@/components/Homepage2'

export const Route = createFileRoute('/v2')({
  component: Homepage2,
})
